import ItemList from '../item-list/item-list.component';
import styles from './sub-menu.module.css';
import PromotedItem from '../promoted-item/promoted-item.component';
import { NavigationNode } from '~/lib/data-contract/auto-generated/api-model';
import clsx from 'clsx';
import React from 'react';
import { CMSLink } from '~/shared/components';

type Props = {
    menuContent?: NavigationNode | null;
    isSelected?: boolean;
    onMenuClick?: (item: NavigationNode | null) => void;
    onNavigationClick?: () => void;
};

export const SubMenu = ({ menuContent, isSelected, onMenuClick, onNavigationClick }: Props) => {
    return (
        <div
            className={clsx(styles.root, {
                [styles.isSelected]: isSelected,
            })}
        >
            <div className={styles.subListSection}>
                {menuContent?.children?.map((subMenu, index) => (
                    <div
                        key={`${index}-${subMenu.link?.id ?? ''}`}
                        className={styles.subListWrapper}
                    >
                        <CMSLink
                            href={subMenu.link?.url}
                            className={clsx(
                                styles.subListHeadline,
                                'hover-effect-underline-center'
                            )}
                            onClick={onNavigationClick}
                        >
                            {subMenu.link?.title}
                        </CMSLink>
                        <ItemList
                            items={subMenu.children || []}
                            isSubList
                            onMenuClick={onMenuClick}
                            onNavigationClick={onNavigationClick}
                        />
                    </div>
                ))}
            </div>
            {menuContent?.promotedChildren?.length ? (
                <div className={styles.subListPromoted}>
                    {menuContent.promotedChildren.map((child) => (
                        <PromotedItem
                            key={child.link?.id}
                            item={child}
                            onNavigationClick={onNavigationClick}
                        />
                    ))}
                </div>
            ) : null}
        </div>
    );
};
